<template>
    <section class="files">
        <div class="files__text">
            <span>{{ $t('kycLevel2Instructions.noDocumentsUploaded') + ' ' }}</span>
            <span>{{ $t('kycLevel2Instructions.documentsLimit', { amount: limit }) }}</span>
        </div>
        <label :class="['files__button', { 'files__button--disabled' : disabled }]">
            {{ $t('kycDocumentTypes.uploadDocuments') }}
            <input type="file"
                multiple
                accept="image/*"
                :disabled="disabled"
                @change="onFilePicked($event)"
            >
        </label>
        <div v-if="images.length"
            class="uploaded-images"
        >
            <div v-for="(item, index) in images"
                :key="index"
                class="uploaded-images__image"
                :style="{ backgroundImage: `url(${item.src})` }"
            >
                <i class="icon-cancel"
                    @click="removePhoto(index)"
                />
                <i class="icon-view-icon"
                    @click="appendModal(item.src)"
                />
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'kyc-files-upload',
    data() {
        return (
            {
                images: [],
                limit: 4,
                image: '',
            }
        );
    },
    computed: {
        disabled() {
            return this.limit === 0;
        },
    },
    methods: {
        appendModal(image) {
            this.$emit('appendModal', image);
        },
        onFilePicked(e) {
            const files = e.target.files;

            if (files.length > 4 || this.limit === 0) {
                this.$notify({
                    type: 'error',
                    text: 'Maximum amount of files exceeded',
                });

                return;
            }

            if (files[0]) {
                Object.keys(files).forEach((key) => {
                    const image = {};
                    const fr = new FileReader();

                    image.name = files[key].name;

                    if (image.name.lastIndexOf('.') <= 0) {
                        return false;
                    }

                    image.src = URL.createObjectURL(files[key]);
                    image.mimeType = files[key].name.split('.').pop();
                    image.format = 'selfie';

                    fr.readAsDataURL(files[key]);

                    fr.addEventListener('load', () => {
                        image.content = fr.result.split(',').pop();
                    });

                    this.images.push(image);
                    this.limit--;

                    this.$emit('fileUpload', this.images);
                });
            }
        },
        removePhoto(index) {
            this.images.splice(index, 1);
            this.limit++;
            this.$emit('fileUpload', this.images);
        },
    },
};
</script>

<style lang="scss" scoped>
.files {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    font-size: 1.5rem;
    line-height: 2.1rem;
    color: $cyprus-color;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;

    @include min-width(xl) {
        flex-direction: row;
    }

    &__text {
        text-align: center;
    }

    &__button {
        cursor: pointer;
        display: block;
        color: $white-color;
        font-size: 1.8rem;
        max-width: 22rem;
        width: 100%;
        border-radius: 0.5rem;
        line-height: 4rem;
        background: $azure-radiance-color;
        text-align: center;
        margin-top: 2rem;

        &:hover {
            opacity: 0.8;
        }

        @include min-width(xl) {
            margin-top: 0;
        }

        &--disabled {
            background: rgba($dusty-gray-color, 0.5);
            pointer-events: none;
        }

        input {
            display: none;
        }
    }
}

.uploaded-images {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;

    @include min-width(lg) {
        justify-content: flex-start;
        margin-left: -2rem;
    }

    &__image {
        margin: 3.5rem 2rem 0;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 13.2rem;
        height: 16.5rem;
        border-radius: 0.36rem;
        border: 0.18rem solid $lima-color;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        font-size: 5rem;

        .icon-cancel {
            position: absolute;
            display: flex;
            align-items: center;
            justify-content: center;
            top: -1.2rem;
            left: -1.2rem;
            width: 2.4rem;
            height: 2.4rem;
            background: $tundora-color;
            color: $white-color;
            border-radius: 100%;
            font-size: 1rem;

            &:hover {
                cursor: pointer;
            }
        }

        .icon-view-icon {
            border-radius: 100%;
            background: rgba($white-color, 0.8);
            color: $lima-color;
            cursor: pointer;
        }

        img {
            width: 100%;
        }
    }
}
</style>